import React from 'react';
import { Check, ChevronDown } from 'lucide-react';
import { BookCallButton } from './BookCallButton';
import { callAgenda, faqs, founderCredentials, foundingBenefits } from '../../data/foundingProgram';
export function FoundingClose() {
  return <>
      {/* Founder */}
      <section className="border-b border-[#D4AF37]/12 bg-[#08070A]" data-id="element-1350" data-mp="33nee9apcgcu8">
        <div className="mx-auto grid w-full max-w-7xl gap-14 px-5 py-20 sm:px-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20 lg:py-24" data-id="element-1351" data-mp="33pscttj8g76j">
          <div data-id="element-1352" data-mp="3velw604xm0kc">
            <div className="flex h-56 w-full max-w-xs items-center justify-center border border-[#D4AF37]/30 bg-[#0F0D12]" data-id="element-1353" data-mp="3vf3ssxviagss">
              <span className="font-serif text-6xl text-[#D4AF37]" aria-hidden="true" data-id="element-1354" data-mp="3hmxnk6tw5u84">
                AS
              </span>
            </div>
            <p className="mt-5 font-serif text-2xl text-[#FDFBF7]" data-id="element-1355" data-mp="e5ypgstm85an">Ash Singh</p>
            <p className="mt-1 text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]" data-id="element-1356" data-mp="ixp1r4c4534p">
              Founder · Sikh Kingdoms
            </p>
          </div>

          <div data-id="element-1357" data-mp="3vm2mhc9y6dna">
            <p className="text-[10px] font-medium uppercase tracking-[0.32em] text-[#D4AF37]" data-id="element-1358" data-mp="3rn3lu3v9131n">
              Who you are meeting
            </p>
            <h2 className="mt-5 font-serif text-3xl leading-tight text-[#FDFBF7] sm:text-5xl" data-id="element-1359" data-mp="99m72p43s1xo">
              You will be on the call with the founder. Not a sales team.
            </h2>
            <p className="mt-6 max-w-2xl text-lg font-light leading-relaxed text-[#FDFBF7]/70" data-id="element-1360" data-mp="j5z3hur18tw4">
              Ash Singh has spent decades at the intersection of Sikh education,
              technology, and culture — and now teaches entrepreneurs how to
              build ventures that last.
            </p>

            <ul className="mt-10 grid gap-px border-t border-[#D4AF37]/15 sm:grid-cols-2" data-id="element-1361" data-mp="n9x1210plwn2">
              {founderCredentials.map(credential => {
              const Icon = credential.icon;
              return <li key={credential.label} className="flex gap-4 border-b border-[#D4AF37]/12 py-6 pr-6" data-id="element-1362" data-mp="2p233r1jnrjp4">
                    <Icon className="mt-1 h-4 w-4 shrink-0 text-[#D4AF37]" aria-hidden="true" data-id="element-1363" data-mp="xwzyifp9tius" />
                    <div data-id="element-1364" data-mp="16wd7765km3eg">
                      <p className="text-[#FDFBF7]" data-id="element-1365" data-mp="16wv9ajewzbua">{credential.label}</p>
                      <p className="mt-1 text-sm font-light text-[#FDFBF7]/50" data-id="element-1366" data-mp="1bvzj9c9nxdlo">
                        {credential.detail}
                      </p>
                    </div>
                  </li>;
            })}
            </ul>
          </div>
        </div>
      </section>

      {/* What Founding Members get */}
      <section className="border-b border-[#D4AF37]/12 bg-[#0B0A0E]" data-id="element-1367" data-mp="1qjkl72usx6s0">
        <div className="mx-auto w-full max-w-7xl px-5 py-20 sm:px-8 lg:py-24" data-id="element-1368" data-mp="1umhblfql276i">
          <div className="max-w-2xl" data-id="element-1369" data-mp="1ukcx63v25prz">
            <p className="text-[10px] font-medium uppercase tracking-[0.32em] text-[#D4AF37]" data-id="element-1370" data-mp="1zkiv21rx88ii">
              The Founding Members
            </p>
            <h2 className="mt-5 font-serif text-3xl leading-tight text-[#FDFBF7] sm:text-5xl" data-id="element-1371" data-mp="3k18ezrg5prg0">
              This is not a donor list. It is a founding cohort.
            </h2>
            <p className="mt-6 text-lg font-light leading-relaxed text-[#FDFBF7]/70" data-id="element-1372" data-mp="3b36k7tn0nv16">
              We are deliberately not chasing large cheques. We are assembling a
              small group of Punjabi executives, professionals, and operators
              whose names, rooms, and judgement carry this into its first
              season.
            </p>
          </div>

          <div className="mt-14 grid gap-px border-t border-[#D4AF37]/15 lg:grid-cols-2" data-id="element-1373" data-mp="3u0pj44frfx9v">
            {foundingBenefits.map(benefit => {
            const Icon = benefit.icon;
            return <article key={benefit.title} className="flex flex-col border-b border-[#D4AF37]/12 py-9 pr-8 lg:[&:nth-child(odd)]:border-r lg:[&:nth-child(odd)]:pr-12 lg:[&:nth-child(even)]:pl-12" data-id="element-1374" data-mp="qdh5rhq86b90">
                  <Icon className="h-6 w-6 text-[#D4AF37]" aria-hidden="true" data-id="element-1375" data-mp="58j6gpki6iim" />
                  <h3 className="mt-7 font-serif text-2xl text-[#FDFBF7]" data-id="element-1376" data-mp="a6kmt2qjo3qe">
                    {benefit.title}
                  </h3>
                  <p className="mt-3 text-base font-light leading-relaxed text-[#FDFBF7]/60" data-id="element-1377" data-mp="14bfsmuhishr">
                    {benefit.body}
                  </p>
                </article>;
          })}
          </div>
        </div>
      </section>

      {/* The call */}
      <section className="border-b border-[#D4AF37]/12 bg-[#08070A]" data-id="element-1378" data-mp="sxvc5fgmg8g6">
        <div className="mx-auto grid w-full max-w-7xl gap-14 px-5 py-20 sm:px-8 lg:grid-cols-2 lg:gap-20 lg:py-24" data-id="element-1379" data-mp="f3kwroqilqms">
          <div data-id="element-1380" data-mp="k1mgmbvrltzb">
            <p className="text-[10px] font-medium uppercase tracking-[0.32em] text-[#D4AF37]" data-id="element-1381" data-mp="k1492j3njtc3">
              The call
            </p>
            <h2 className="mt-5 font-serif text-3xl leading-tight text-[#FDFBF7] sm:text-5xl" data-id="element-1382" data-mp="1ck9ryzkylun7">
              Twenty-five minutes. Four things.
            </h2>
            <ul className="mt-10 space-y-5" data-id="element-1383" data-mp="1lwh44jqnzr6c">
              {callAgenda.map(item => <li key={item} className="flex gap-4" data-id="element-1384" data-mp="1huvt73xoxmys">
                  <Check className="mt-1 h-4 w-4 shrink-0 text-[#D4AF37]" aria-hidden="true" data-id="element-1385" data-mp="1vomszklmdshb" />
                  <span className="text-base font-light leading-relaxed text-[#FDFBF7]/70" data-id="element-1386" data-mp="1qrmkz457mfnk">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div data-id="element-1387" data-mp="1cxvoawckuq99">
            <p className="text-[10px] font-medium uppercase tracking-[0.32em] text-[#D4AF37]" data-id="element-1388" data-mp="1cyeu5eoydo6x">
              Questions people ask first
            </p>
            <div className="mt-8 border-t border-[#D4AF37]/15" data-id="element-1389" data-mp="17xhdx7ni7482">
              {faqs.map(faq => <details key={faq.question} className="group border-b border-[#D4AF37]/12" data-id="element-1390" data-mp="2ob7liodu0amg">
                  <summary className="flex cursor-pointer list-none items-center justify-between gap-6 py-5 text-left text-[#FDFBF7] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37]" data-id="element-1391" data-mp="2rf6o266p5yut">
                    <span className="font-light" data-id="element-1392" data-mp="30f22cjvju9z2">{faq.question}</span>
                    <ChevronDown className="h-4 w-4 shrink-0 text-[#D4AF37] transition-transform duration-200 ease-out group-open:rotate-180" aria-hidden="true" data-id="element-1393" data-mp="35eenn06rv8zj" />
                  </summary>
                  <p className="pb-6 pr-10 text-sm font-light leading-relaxed text-[#FDFBF7]/55" data-id="element-1394" data-mp="2cqivm8s5e593">
                    {faq.answer}
                  </p>
                </details>)}
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="bg-[#0B0A0E]" data-id="element-1395" data-mp="1p0y95fwscpv2">
        <div className="mx-auto w-full max-w-3xl px-5 py-24 text-center sm:px-8 lg:py-32" data-id="element-1396" data-mp="1oy2bztsri57o">
          <p className="text-[10px] font-medium uppercase tracking-[0.32em] text-[#D4AF37]" data-id="element-1397" data-mp="1txeyuejmvca9">
            One decision
          </p>
          <h2 className="mt-6 font-serif text-4xl leading-[1.05] text-[#FDFBF7] sm:text-6xl" data-id="element-1398" data-mp="1hgnmdbjsjsl4">
            Put your name on the court before the doors open.
          </h2>
          <p className="mx-auto mt-7 max-w-xl text-lg font-light leading-relaxed text-[#FDFBF7]/65" data-id="element-1399" data-mp="1cfpyqjg0i6c8">
            Founding Membership closes when the cohort is full. If this is
            yours, take twenty-five minutes and find out on a call.
          </p>
          <div className="mt-11 flex justify-center" data-id="element-1400" data-mp="ypw4fllqmtv4">
            <BookCallButton size="lg" data-id="element-1401" data-mp="yobcm3qt5p0y">
              Book a call with the founding team
            </BookCallButton>
          </div>
        </div>
      </section>
    </>;
}